import Api from 'services/Api';
import moment from 'moment';
import Vue from 'vue';

export const types = {
    RESET: 'RESET',
    SET_API_REQUEST_IN_PROGRESS: 'SET_API_REQUEST_IN_PROGRESS',
    SET_API_REQUEST_COMPLETE: 'SET_API_REQUEST_COMPLETE',
    UPDATE_FULL_LIST: 'UPDATE_FULL_LIST',
    UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
    UPDATE_DATA: 'UPDATE_DATA',
    TOGGLE_EDITING_DOCUMENT: 'TOGGLE_EDITING_DOCUMENT',
    QUIT_EDITING_DOCUMENT: 'QUIT_EDITING_DOCUMENT',
    DELETE_GENERATED_DOCUMENT: 'DELETE_GENERATED_DOCUMENT',
    UPDATE_SHOW_INTEREST: 'UPDATE_SHOW_INTEREST',
    EXIT_EDITING_DOCUMENT_ATTEMPTED: 'EXIT_EDITING_DOCUMENT_ATTEMPTED',
    EXIT_EDITING_DOCUMENT_FAILED: 'EXIT_EDITING_DOCUMENT_FAILED',
    UPDATE_DOCUMENT_NAME: 'UPDATE_DOCUMENT_NAME',
    UPDATE_PAGINATION: 'UPDATE_PAGINATION',
    UPDATE_HEADS_OF_LOSS: 'UPDATE_HEADS_OF_LOSS'
};

// Initial State
const state = {
    requesting: false,
    generatedDocuments: [],
    editingDocument: -1,
    exitAllowed: false,
    showingExitNotification: false,
    pagination: {
        total: 0,
        per_page: 0,
        from: 0,
        to: 0,
        current_page: 0,
        last_page: 0
    },
    headsOfLoss: {}
};

// Getters
const getters = {
    getRequestStatus: state => state.requesting,
    getGeneratedDocuments: () => state.generatedDocuments,
    getGeneratedDocument: state => index => state.generatedDocuments[index],
    getEditingDocument: state => state.editingDocument,
    getShowInterest: state => index => state.generatedDocuments[index].show_interest,
    getDocumentDataByKey: state => ({ index, key }) => {
        // This is really dirty...
        if (typeof index === 'undefined') { return 0; }
        if (state.generatedDocuments[index].data === null) { return 0; }
        return state.generatedDocuments[index].data[key];
    },
    showingExitNotification: state => state.showingExitNotification,
    getExitAllowed: state => state.exitAllowed,
    getDocumentsByType: state => type => state.generatedDocuments.filter(generatedDocument => generatedDocument.type === type).sort((a, b) => moment(a.updated_at, 'YYYY-MM-DD HH:mm:ss')
                .isBefore(moment(b.updated_at, 'YYYY-MM-DD HH:mm:ss')) ? 1 : -1),
    getPagination: () => state.pagination,
    getHeadsOfLoss: state => state.headsOfLoss,
};

// Actions
const actions = {
    resetDocuments({ commit }) {
        commit(types.RESET);
    },
    setApiRequestInProgress({ commit }) {
        commit(types.SET_API_REQUEST_IN_PROGRESS);
    },
    setApiRequestComplete({ commit }) {
        commit(types.SET_API_REQUEST_COMPLETE);
    },
    quitEditingDocument({ commit }) {
        commit(types.QUIT_EDITING_DOCUMENT);
    },
    exitAttempted({commit}) {
        commit(types.EXIT_EDITING_DOCUMENT_ATTEMPTED);
    },
    exitClosed({commit}) {
        commit(types.EXIT_EDITING_DOCUMENT_FAILED);
    },
    toggleEditingDocument({ commit }, document) {
        commit(types.TOGGLE_EDITING_DOCUMENT, document);
    },
    deleteGeneratedDocument({ commit, dispatch }, document) {
        dispatch('setApiRequestInProgress');
        return Api.generatedDocuments.delete(document).then(() => {
            commit(types.DELETE_GENERATED_DOCUMENT, document);
            dispatch('setApiRequestComplete');
        }
    )},
    getGeneratedDocumentsFromServer({ commit, dispatch }, {claimId, page, filter} ) {
        dispatch('setApiRequestInProgress');
        return Api.generatedDocuments.load(claimId, page, filter).then((data) => {
            commit(types.UPDATE_FULL_LIST, data);
            commit(types.UPDATE_PAGINATION, data);
            dispatch('setApiRequestComplete');
        }
        );},
    saveGeneratedDocument({ commit }, { index, document }) {
        return Api.generatedDocuments.save(document).then((data) => {
            commit(types.UPDATE_DOCUMENT, { data, index });
        }
        );
    },
    createGeneratedDocument({ commit, dispatch, getters }, { type, claimId, claimType, discountRate }) {
        return Api.generatedDocuments
            .create(type, claimId, claimType, discountRate)
            .then((data) => {
                commit(types.UPDATE_FULL_LIST, data);
                dispatch('toggleEditingDocument', getters['getDocumentsByType'](type)[0]);
                return data;
            }
        );
    },
    updateDocument({ dispatch }, { index, document }) {
        const proms = Object.keys(document)
            .filter(userSettable()) // This is undefined, how is this supposed to work?!
            .map(key => dispatch('updateDocumentValue', { key, value: document[key], index }));

        return Promise.all(proms);
    },
    updateDocumentName({ commit }, { index, value }) {
        commit(types.UPDATE_DOCUMENT_NAME, { index, value });
    },
    updateDataByKey({ commit }, { index, key, value }) {
        commit(types.UPDATE_DATA, { index, key, value });
    },
    updateShowInterest({ commit }, { index }) {
        commit(types.UPDATE_SHOW_INTEREST, { index });
    },
    getMoveableHeadsOfLoss({ commit }, {claimId, discountRate}) {
        return Api.generatedDocuments.headsOfLoss(claimId, discountRate).then((data) => {
                commit(types.UPDATE_HEADS_OF_LOSS, data);
            }
        );
    },
};


// Mutations
const mutations = {
    [types.RESET](state) {
        state.generatedDocuments = [];
    },
    [types.UPDATE_FULL_LIST](state, data) {
        state.generatedDocuments = data.sort((a, b) => moment(a.updated_at, 'YYYY-MM-DD HH:mm:ss')
            .isBefore(moment(b.updated_at, 'YYYY-MM-DD HH:mm:ss')) ? 1 : -1);
    },
    [types.UPDATE_DOCUMENT](state, { index, data }) {
        state.generatedDocuments[index] = data;
    },
    [types.UPDATE_DOCUMENT_NAME](state, { index, value }) {
        state.generatedDocuments[index].name = value;
    },
    [types.UPDATE_DATA](state, { index, key, value }) {
        if(!value) {
            value = 0;
        }
        Vue.set(state.generatedDocuments[index].data, key, value);
    },
    [types.DELETE_GENERATED_DOCUMENT](state, document) {
        state.generatedDocuments.splice(state.generatedDocuments.indexOf(document), 1);
    },
    [types.TOGGLE_EDITING_DOCUMENT](state, document) {
        state.editingDocument = state.generatedDocuments.map(document => document.id).indexOf(document.id);
    },
    [types.QUIT_EDITING_DOCUMENT](state) {
        state.showingExitNotification = false;
        state.exitAllowed = false;
        state.editingDocument = -1;
    },
    [types.SET_API_REQUEST_IN_PROGRESS](state) {
        state.requesting = true;
    },
    [types.SET_API_REQUEST_COMPLETE](state) {
        state.requesting = false;
    },
    [types.UPDATE_SHOW_INTEREST](state, { index }) {
        if (state.generatedDocuments[index].show_interest === 1) {
            state.generatedDocuments[index].show_interest = 0;
        } else {
            state.generatedDocuments[index].show_interest = 1;
        }
    },
    [types.EXIT_EDITING_DOCUMENT_ATTEMPTED](state) {
        state.showingExitNotification = true;
        state.exitAllowed = true;
    },
    [types.EXIT_EDITING_DOCUMENT_FAILED](state) {
        state.showingExitNotification = false;
        state.exitAllowed = false;
    },
    [types.UPDATE_PAGINATION](state, data) {
        state.pagination.total = data.total;
        state.pagination.per_page = data.per_page;
        state.pagination.from = data.from;
        state.pagination.to = data.to;
        state.pagination.current_page = data.current_page;
        state.pagination.last_page = data.last_page;
    },
    [types.UPDATE_HEADS_OF_LOSS](state, data) {
        state.headsOfLoss = data.heads_of_loss;
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/documents.js